import type { TimeSlotAnalysisResponse, TimeSlotDimension, TimeSlotSegmentLimit } from "../api/client";

export const GEO_TIME_SLOT_TOP_LIMIT = 10;

export type GeoTimeSlotScope = "top10" | "all";
export type DeviceTimeSlotScope = "all" | (string & {});

export function resolveTimeSlotSegmentLimit(dimension: TimeSlotDimension, geoScope: GeoTimeSlotScope): TimeSlotSegmentLimit {
  if (dimension === "device") return "all";
  return geoScope === "top10" ? GEO_TIME_SLOT_TOP_LIMIT : "all";
}

export function filterTimeSlotAnalysisBySegment(
  data: TimeSlotAnalysisResponse | null,
  selectedSegment: DeviceTimeSlotScope
): TimeSlotAnalysisResponse | null {
  if (!data || selectedSegment === "all") return data;

  return {
    ...data,
    segments: {
      results: data.segments.results.filter((row) => row.segment === selectedSegment)
    },
    hourly: {
      results: data.hourly.results.filter((row) => row.segment === selectedSegment)
    },
    weekly: {
      results: data.weekly.results.filter((row) => row.segment === selectedSegment)
    }
  };
}
